import { useMutation, UseMutationOptions } from "@tanstack/react-query";

import { Asset } from "@/types/assets";

import { getAsset, uploadAsset } from "./assetsApi";

export default function useBatchGetAssets(
  options?: Omit<UseMutationOptions<Asset[], Error, string[]>, "mutationFn">
) {
  return useMutation({
    mutationFn: async (assetIds: string[]) => {
      const promises = assetIds.map((id) => getAsset(id));
      return Promise.all(promises);
    },
    ...options
  });
}

export const useUploadAssetMutation = (
  options?: UseMutationOptions<
    { id: string },
    Error,
    { file: Blob; filename?: string }
  >
) => {
  return useMutation({
    mutationFn: ({ file, filename }: { file: Blob; filename?: string }) =>
      uploadAsset(file, filename),
    ...options
  });
};
